const IS_PUBLIC_BRANDING = process.env.GATSBY_BRANDING === "public";

const MARKETING_URL = IS_PUBLIC_BRANDING
  ? (process.env.GATSBY_MARKETING_URL || "").replace(/\/$/, "")
  : "";

const APP_URL = IS_PUBLIC_BRANDING
  ? (process.env.GATSBY_APP_URL || "").replace(/\/$/, "")
  : "";

const APP_HOST = APP_URL
  ? (() => {
      try {
        return new URL(APP_URL).hostname;
      } catch {
        return "app.thgquoten.com";
      }
    })()
  : "app.thgquoten.com";

const INTERNAL_PATHS = {
  agb: "/agb",
  datenschutz: "/datenschutz",
  impressum: "/impressum",
  widerrufsbelehrung: "/widerrufsbelehrung",
  contact: "/contact",
  faq: "/faq",
  wallbox: "/wallbox",
};

const LANDING_SECTIONS = {
  vorteile: "vorteile",
  dienstleistungen: "dienstleistungen",
  lis: "lis",
  ablauf: "ablauf",
  beschreibung: "beschreibung",
};

export function isMarketingExternal() {
  return Boolean(MARKETING_URL);
}

export function isAppExternal() {
  return Boolean(APP_URL);
}

/** Internal "/" when unset, marketing site root when GATSBY_MARKETING_URL is set. */
export function marketingHomeHref() {
  return MARKETING_URL ? `${MARKETING_URL}/` : "/";
}

/** Internal /#hash when unset, marketing site section when GATSBY_MARKETING_URL is set. */
export function marketingHashHref(section) {
  const hash = LANDING_SECTIONS[section] || section;
  const fragment = hash.startsWith("#") ? hash : `#${hash}`;

  if (!MARKETING_URL) {
    return `/${fragment}`;
  }

  return `${MARKETING_URL}/${fragment}`;
}

/** Internal path when unset, absolute marketing URL when GATSBY_MARKETING_URL is set. */
export function marketingHref(key) {
  if (!MARKETING_URL) {
    return INTERNAL_PATHS[key];
  }

  return `${MARKETING_URL}${INTERNAL_PATHS[key]}/`;
}

/** Relative path when unset, absolute app URL when GATSBY_APP_URL is set. */
export function appHref(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (!APP_URL) {
    return normalizedPath;
  }

  return `${APP_URL}${normalizedPath}`;
}

/** True when the landing page must not be shown (app host in split deployment). */
export function shouldRedirectAppLanding() {
  if (typeof window === "undefined" || !isMarketingExternal()) {
    return false;
  }

  return window.location.hostname === APP_HOST;
}
